import { FooterStyled } from 'components/FooterStyled/styled'
import styled from 'styled-components'

import { media } from 'featureSliced/shared/utils/breakpoints'

export const BucketContainer = styled.div`
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 70px;
  &::after {
    content: unset;
  }
`

export const BucketProductsContainer = styled.div`
  height: 100%;
  overflow-y: scroll;
  background-color: ${({ theme }) => theme.MainBackGround};
  padding: 0;

  /* reserves room for the fixed web footer below, so the last line isn't hidden under it */
  ${media.web} {
    padding-bottom: 160px;
  }
`

export const BucketFooter = styled(FooterStyled)`
  position: sticky;
  z-index: 2;
  left: 0;
  right: 0;
  bottom: 0;
  top: env(safe-area-inset-bottom);

  /* unlike the other checkout steps, this footer must stay pinned and reachable
     while the order list scrolls underneath it — override FooterStyled's own
     media.web, which otherwise turns it into an in-flow card */
  ${media.web} {
    position: fixed;
    width: auto;
    top: auto;
    left: 24px;
    right: 24px;
    bottom: 24px;
  }
`

export const BucketButtonContainer = styled.div`
  grid-row: 2 / -1;
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
`

export const Total = styled.div`
  grid-row: 1 / 2;
  grid-column: 1 / -1;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &::after {
    content: unset;
  }
  span {
    line-height: 30px;
    font-size: 17px;
    font-weight: 500;

    color: ${({ theme }) => theme.FontColor};
  }
  span:last-child {
    color: ${({ theme }) => theme.colour};
  }
`
